import http from '../../../plugins/axios';

export default {

  getProjectList(data) {
    return http.get({
      url: '/admin/project/list',
      data
    })
  },

  updateStatus(data) {
    return http.post({
      url: '/admin/project/status',
      data,
      dataType: 'form'
    })
  },

    updateSwitch(data) {
        return http.post({
            url: '/admin/project/switch',
            data,
            dataType: 'form'
        })
    },

  updateProject(data) {
    return http.post({
      url: '/admin/project/alter',
      data,
      dataType: 'form'
    })
  },
  delProject(data) {
    return http.post({
      url: '/admin/project/del',
      data,
      dataType: 'form'
    })
  },

  addProject(data) {
    return http.post({
      url: '/admin/project/add',
      data,
      dataType: 'form'
    })
  },

  balanceList(data) {
    return http.get({
      url: '/admin/project/balance',
      data
    })
  },

  balanceExport(data) {
    return http.post({
      url: '/admin/project/balance/export',
      data,
      dataType: 'form',
      responseType: 'blob'
    })
  }
}
